import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

/**
 * Table Empty State Component (hx-table-empty-state)
 *
 * Displays a visual placeholder with an illustration and a customizable message when a table has no data. Used by
 * HxManagedTableComponent when the data array is empty.
 *
 * @example
 *   ```html
 *   <hx-table-empty-state message="Create your first client to see the list view." />
 *   ```;
 */
@Component({
  selector: 'hx-table-empty-state',
  standalone: true,
  templateUrl: './table-empty-state.html',
  styleUrl: './table-empty-state.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HxTableEmptyStateComponent {
  /** Message to display beneath the illustration */
  readonly message = input<string>('No data available');
}
